/* BLLOOW — barra de envío gratis dinámica (recalcula según el carrito)
   Umbral: 39€. Solo actualiza el segmento .bl-ship de la barra de anuncios;
   el resto del mensaje (24-48h, garantía) se mantiene. */
(function () {
  if (window.__blloowShipInit) return;
  window.__blloowShipInit = true;

  var THRESHOLD = 3900; // 39,00€ en céntimos (cambiar aquí si cambia el umbral)

  function euros(cents) {
    var e = cents / 100;
    var s = (e % 1 === 0) ? e.toString() : e.toFixed(2).replace('.', ',');
    return s + '€';
  }

  function render(total) {
    var els = document.querySelectorAll('.bl-ship');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.orig == null) el.dataset.orig = el.innerHTML;
      if (total <= 0) {
        el.innerHTML = el.dataset.orig;
        el.classList.remove('bl-ship--done', 'bl-ship--progress');
      } else if (total >= THRESHOLD) {
        el.innerHTML = '🎉 ¡<strong>Envío gratis</strong> conseguido!';
        el.classList.add('bl-ship--done');
        el.classList.remove('bl-ship--progress');
      } else {
        var left = THRESHOLD - total;
        el.innerHTML = '🚚 Añade <strong>' + euros(left) + '</strong> más y consigue <strong>envío gratis</strong>';
        el.classList.add('bl-ship--progress');
        el.classList.remove('bl-ship--done');
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }

  // Recalcular cuando cambie el carrito (add / change / update / clear)
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var args = arguments;
      return _fetch.apply(this, args).then(function (res) {
        try {
          var u = (args[0] && args[0].url) ? args[0].url : args[0];
          if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) {
            setTimeout(refresh, 80);
          }
        } catch (e) {}
        return res;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
